export function isFunctionHooked(fn: (...args: unknown[]) => unknown) {
  if (typeof fn !== 'function') {
    return true;
  }

  return !fn.toString().includes('[native code]');
}

export function checkBrowserConsistency() {
  const ua = navigator.userAgent;
  const platform = navigator.platform;
  const maxTouchPoints = navigator.maxTouchPoints;
  const isMobileUA = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
  const isTabletUA = /iPad|Android(?!.*Mobile)|Tablet/i.test(ua);
  const isIPhoneUA = /iPhone/i.test(ua);
  const isIPadUA = /iPad/i.test(ua);
  const isAndroidUA = /Android/i.test(ua);
  const isWindowsUA = /Windows/i.test(ua);
  const isMacUA = /Macintosh|Mac OS X/i.test(ua);

  // 触摸点检测及是否支持触摸事件
  const isTouch = 'ontouchstart' in window || maxTouchPoints > 0;

  // 平台与UA一致性
  let platformConsistent = true;
  if (isIPhoneUA && !/iPhone|iPad|iPod/i.test(platform)) platformConsistent = false;
  if (isIPadUA && !/iPad/i.test(platform)) platformConsistent = false;
  if (isAndroidUA && !/Android/i.test(platform)) platformConsistent = false;
  if (isWindowsUA && !/Win/i.test(platform)) platformConsistent = false;
  if (isMacUA && !/Mac/i.test(platform)) platformConsistent = false;

  // 触摸点与UA一致性（优化：用isTouch判断）
  let touchConsistent = true;
  if ((isMobileUA || isTabletUA) && !isTouch) touchConsistent = false;

  // UA与平台、触摸点、特征等综合判断
  const isConsistent = platformConsistent && touchConsistent;

  return isConsistent;
}
